<template>
    <div v-if="visible" class="drawer-overlay" @click="close">
      
      <div class="drawer" @click.stop>
  
        <div class="drawer-handle"></div>
  
        <img src="/app_preview.png" class="drawer-image" />
  
        <h2 class="drawer-title">
          Установите Hr3
        </h2>
  
        <p class="drawer-description">
          Намного удобнее искать работу и откликаться на вакансии через приложение.
        </p>
  
        <a
          href="https://apps.apple.com/ru/app/hyper/id1472576770"
          target="_blank"
          class="appstore-button"
        >
          <img src="/appstore_icon.png" />
        </a>
  
        <button class="close-button" @click="close">
          Продолжить в браузере
        </button>
  
      </div>
    </div>
  </template>
  
  <script setup>
  
  import { ref, onMounted } from "vue";
  
  const visible = ref(false);
  
  function isMobile() {
    return window.innerWidth < 768;
  }
  
  function close() {
    visible.value = false;
    localStorage.setItem("apple_drawer_closed", "true");
  }
  
  onMounted(() => {
  
    const closed = localStorage.getItem("apple_drawer_closed");
  
    if (!closed && isMobile()) {
      setTimeout(() => {
        visible.value = true;
      }, 1200);
    }
  
  });
  
  </script>
  
  <style scoped>
  
  .drawer-overlay{
    position:fixed;
    inset:0;
    background:rgba(0,0,0,0.4);
    display:flex;
    justify-content:center;
    align-items:flex-end;
    z-index:9999;
  }
  
  .drawer{
    width:100%;
    max-width:600px;
    height:50vh;
    background:white;
    border-radius:20px 20px 0 0;
    padding:28px;
    text-align:center;
    animation:slideUp .35s ease;
  }
  
  @keyframes slideUp{
    from{
      transform:translateY(100%);
    }
    to{
      transform:translateY(0);
    }
  }
  
  .drawer-handle{
    width:44px;
    height:5px;
    background:#ddd;
    border-radius:10px;
    margin:0 auto 20px;
  }
  
  .drawer-image{
    width:160px;
    margin-bottom:20px;
  }
  
  .drawer-title{
    font-size:22px;
    font-family:"Eastman-Bold";
    margin-bottom:10px;
  }
  
  .drawer-description{
    font-size:14px;
    color:#666;
    margin-bottom:20px;
  }
  
  .appstore-button {
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  text-decoration: none;

  margin-top: 8px;
  margin-bottom: 20px;
}

.appstore-button img {
  display: block;

  width: 170px;
  height: auto;

  transition: transform 0.2s ease,
              opacity 0.2s ease;
}

.appstore-button:hover img {
  transform: scale(1.03);
  opacity: 0.92;
}

.appstore-button:active img {
  transform: scale(0.97);
}
  
  .close-button{
    background:none;
    border:none;
    color:#777;
    font-size:14px;
  }

  /* LIGHT */

[data-theme="light"] .drawer{
  background:white;
}

[data-theme="light"] .drawer-title{
  color:#111;
}

[data-theme="light"] .drawer-description{
  color:#666;
}

[data-theme="light"] .drawer-handle{
  background:#ddd;
}

[data-theme="light"] .close-button{
  color:#777;
}

/* DARK */

[data-theme="dark"] .drawer{
  background:#1f1f1f;
}

[data-theme="dark"] .drawer-title{
  color:white;
}

[data-theme="dark"] .drawer-description{
  color:#aaa;
}

[data-theme="dark"] .drawer-handle{
  background:#444;
}

[data-theme="dark"] .close-button{
  color:#aaa;
}

.drawer {
  width: 100%;
  max-width: 600px;
  min-height: 460px;

  background: white;
  border-radius: 24px 24px 0 0;

  padding: 24px;

  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;

  animation: slideUp .35s ease;
}
  
  </style>